// Delay short bursts and keep the indicator steady across gaps in asset work.
export class LoadingIndicator {
    constructor(delay = 250, quiet = 750) { this.delay = delay; this.quiet = quiet; this.reset(); }
    reset() { this.started = null; this.idle = null; this.visible = false; }
    update(active, now) {
        if (active) {
            this.idle = null; this.started ??= now;
            if (now - this.started >= this.delay) this.visible = true;
        } else if (this.visible) {
            this.idle ??= now;
            if (now - this.idle >= this.quiet) this.reset();
        } else this.reset();
        return this.visible;
    }
}
